<template>
  <div class="searchIndex wrapper">
    <div class="ques-detail detail-container" :style="{ borderColor: borderColor }">
      <fieldset
        id="quesDetail"
        class="quesborder left"
        s="math"
        @click="openOrCloseDetail"
        :style="{ borderColor: borderColor }">
        <div class="content">
          <div class="pt1">
            <div v-if="question.QuestionStem && question.QuestionStem.length > 0" v-html="question.QuestionStem"></div>
            <img v-else :src="question.QuestionStemImage" alt="题干" />
          </div>
        </div>

        <div v-show="openDetail">
          <div v-if="question.KnowledgePoints && question.KnowledgePoints.length > 0" class="pt3">
            <!--B3-->
            <em>【考点】</em>
            <a v-for="point in question.KnowledgePoints" :key="'que-point' + point.PointNo" :href="'#' + point.PointNo">
              {{ point.PointName }}、
            </a>
          </div>

          <div v-if="question.Answer" class="pt11">
            <!--B4-->
            <em>【答案】</em>
            <div v-html="question.Answer"></div>
          </div>
          <div v-if="question.Explain" class="pt5">
            <!--B5-->
            <em>【解析】</em>
            <div v-html="question.Explain"></div>
          </div>
        </div>
      </fieldset>
      <div class="right">
        <div class="correct">
          <div class="" :style="{ color: borderColor }">
            <span>正确率：{{ analysisData.CorrectRate }} %</span>
          </div>
          <div class="">
            <span>{{ analysisData.RightNum }}人对 | {{ analysisData.TotalNum }}人答题</span>
          </div>
        </div>

        <div class="students">
          <div class="student_list">
            <span class="tip">作错：</span>
            <p>
              <span class="student" v-for="(student, index) in analysisData.StudentWrong" :key="'wrong' + index">
                {{ student }}、
              </span>
            </p>
          </div>
          <div class="student_list">
            <span class="tip">作对：</span>
            <p>
              <span class="student" v-for="(student, index) in analysisData.StudentRight" :key="'right' + index">
                {{ student }}、
              </span>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
/* import "../../assets/css/questionStyle.css";
import "../../assets/js/library.js"; */
export default {
  name: "QuestionDetail",
  props: {
    // 作业试题
    question: {},
    analysisData: {
      type: Object,
      default: function () {
        return {
          QuestionNum: 1, //题号
          QuestionID: 5690, //作业原题的id
          TotalNum: 1, //答题人数
          RightNum: 0, //答对人数
          ErrorNum: 1, //答错人数
          CorrectRate: 0, //正确率
          Answer: "B", //正确答案
          StudentRight: [], //答对的学生姓名
          StudentWrong: [], //答错的学生姓名
          PushQuestion: [],
        };
      },
    },
    borderColor: {
      type: String,
      default: "#00a2e8",
    },
    openDetail: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
    };
  },
  mounted() {},
  updated() {},
  methods: {
    /* 展开或关闭试题解析详情 */
    openOrCloseDetail() {
      this.openDetail = !this.openDetail;
    },
  },
};
</script>
<style lang="less">
.detail-container {
  display: flex;
  margin-left: 15px;
  border: 2px solid #00a2e8;
  .left {
    width: 60%;
    border-right: 2px solid #00a2e8;
    cursor: pointer;
  }
  .right {
    width: 40%;
    padding: 10px;
    font-size: 15px;
    line-height: 36px;
    .correct {
      font-size: 16px;
      font-weight: 600;
      display: flex;
      color: #797979;
      justify-content: space-between;
    }
    .students {
      .student_list {
        position: relative;
        min-height: 36px;
        span.tip {
          position: absolute;
        }
        p {
          padding-left: 50px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/detail/QuestionDetail.vue